export const TEXT_KEYS = {
    REDEEM_ERROR_TITLE: 'redeem-error-own-all-items__title',
    REDEEM_ERROR_MESSAGE: 'redeem-error-own-all-items__message',
    REDEEM_ERROR_SUPPORT: 'redeem-error-own-all-items__support',
};
